import React from 'react'

import { Skeleton } from 'antd'
import {
  CardText,
  CardValueBig,
  SingleCard,
  CardValueLight
} from 'components/InfoCardsUpdate/style'
import { IconTextContainer, TextWrapper } from './style'

const InfoCardsUpdate = ({
  background,
  padding = '15px 25px',
  width = 'auto',
  icon,
  text,
  value,
  onClick,
  isSelected = false,
  borderColor,
  loading,
  IconText,
  backgroundColor,
  textColor,
  style,
  isFirst,
  showStudentDetails,
}) => {
  return (
    <SingleCard
      data-test={background}
      background={backgroundColor || background}
      padding={padding}
      width={width}
      column
      flexStart
      onClick={onClick}
      borderColor={showStudentDetails && isFirst? '1px solid #3249D7' : borderColor}
      style={style}
    >
      {isFirst && <CardValueLight>{showStudentDetails ? 'Viewing the' : 'Click to view'}</CardValueLight>}
      <IconTextContainer>
        {icon}
        {IconText && <TextWrapper style={{color:textColor}}>{IconText}</TextWrapper>}
      </IconTextContainer>

      {loading ? (
        <Skeleton.Avatar active={true} size={'default'} shape={'square'} />
      ) : (
        <CardValueBig isSelected={isSelected} textColor={textColor}>{value}</CardValueBig>
      )}
      {/* {!isFirst && <CardText isSelected={isSelected} textColor={textColor}>{text}</CardText>} */}
    </SingleCard>
  )
}

export default InfoCardsUpdate
